import { useCallback, useState } from 'react';

import { AutopsyActBrief } from '@/api/pathology/types';
import { useLazyDownloadAutopsyActQuery } from '@/api/report/api';
import { getAutopsyActFileName } from '@/pages/Pathology/helpers';
import { useAppNotification } from '@/shared/hooks/useAppNotification';
import { downloadBlob } from '@/utils/utils';

type PrintableAct = Pick<
  AutopsyActBrief,
  'id' | 'individualInventoryNumber' | 'performedAt'
>;

// Печатная форма акта (PDF) формируется в report-ms
export const useAutopsyActPrint = () => {
  const { showWarning } = useAppNotification();
  const [downloadAct] = useLazyDownloadAutopsyActQuery();
  const [printingId, setPrintingId] = useState<string | null>(null);

  const print = useCallback(
    async (act: PrintableAct) => {
      setPrintingId(act.id);

      try {
        const { data, meta } = await downloadAct({ actId: act.id }, false).unwrap();

        if (meta.response?.status === 204) {
          showWarning('Внимание!', 'Отсутствуют данные для формирования файла');
          return;
        }

        downloadBlob(data, getAutopsyActFileName(act));
      } catch {
        // ошибка уже показана в baseQueryWithReAuth
      } finally {
        setPrintingId(null);
      }
    },
    [downloadAct, showWarning],
  );

  return { print, printingId };
};
